import { render } from "./CeibaDevice.vue?vue&type=template&id=94a056d4"
import script from "./CeibaDevice.vue?vue&type=script&lang=js"
export * from "./CeibaDevice.vue?vue&type=script&lang=js"
script.render = render

export default script